module.exports = __webpack_public_path__ + "img/Groups.7247851f.svg";